// This is being provided by webpack through the Define plugin
// and resolved via an alias
export default CONFIG; // eslint-disable-line
